<template>
  <Dialog class="mobile box-record-dialog" :modelValue="props.modelValue" @update:modelValue="updateModelValue" type="common" :showClose="true">
    <div class="content">
      <div class="title">{{ $t('mwr.dragon.boxRecord.title') }}</div>
      <div class="table">
        <div class="thead">
          <div class="tr">
            <div class="th box-name">
              {{ $t('mwr.dragon.boxRecord.box') }}
            </div>
            <div class="th reward">
              {{ $t('mwr.dragon.boxRecord.reward') }}
            </div>
            <div class="th time">
              {{ $t('mwr.dragon.boxRecord.time') }}
            </div>
          </div>
        </div>
        <div class="tbody" v-if="mwrData.recordList.length > 0">
          <div class="tr" v-for="(item, index) in mwrData.recordList" :key="index">
            <div class="td box-name">
              {{ $t(`mwr.dragon.boxRecord.box${item.stage}Name`) }}
            </div>
            <div class="td reward">
              <!-- {{ item.rewardItems }} -->
              <div class="reward-item" v-for="(reward, index) in item.rewardItems" :key="index">
                <span class="reward-item-name">
                  {{ $t(`props.${reward.itemId}`) }}: 
                </span>
                <span class="reward-item-count">
                  {{ reward.quantity }}
                </span>
              </div>
            </div>
            <div class="td time">
              {{ dayjs(item.createTime).format('YYYY-MM-DD HH:mm:ss') }}
            </div>
          </div>
        </div>
        <div class="empty-data" v-if="mwrData.recordList.length === 0">
          {{ $t('payment.noData') }}
        </div>
      </div>
    </div>
  </Dialog>
</template>
<script setup>
/* eslint-disable */
import Dialog from '@/components/Dialog/ActMwr/index.vue'
import { defineProps, defineEmits } from 'vue'
import { inject } from 'vue'
import dayjs from 'dayjs'
const mwrData = inject('mwrData')
console.log('mwrData', mwrData)
const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false
  }
})
const emit = defineEmits(['update:modelValue'])
const updateModelValue = (value) => {
  emit('update:modelValue', value)
}

</script>

<style lang="less" scoped src="./mobile_style.less"></style>
